import { Logo } from 'palette/Logo';
import '../styles/FooterIconApp.scss';

export function FooterIconApp({ url, name }) {
    return (
        <a
            aria-label={name}
            className="react-footer-icon-app"
            href={url}
            rel="noopener noreferrer"
            target="_blank"
        >
            <Logo
                name={name}
            />
        </a>
    );
}
